import { call, all, put, takeEvery } from 'redux-saga/effects';

import { graphql } from '../../../globals/api/requests';

import actions, { USER_ACCEPT_TERMS_REQUEST } from '../actions';

export function acceptPolicyRequest(policyType) {
  return call(
    graphql,
    `
    mutation($data: AcceptPolicy!) {
      acceptPolicy(data: $data) {
        success
      }
    }
    `,
    {
      data: {
        policyType,
      },
    }
  );
}

export function* termsAccepted({ policyTypes }) {
  try {
    const responses = yield all(policyTypes.map(acceptPolicyRequest));

    const failedResponses = responses.filter(
      res => !res.data.acceptPolicy.success
    );

    if (failedResponses.length > 0) {
      yield put(actions.acceptTermsFailed());
      return;
    }
    yield put(actions.acceptTermsComplete());
  } catch (e) {
    yield put(actions.acceptTermsFailed());
  }
}

function* mySaga() {
  yield takeEvery(USER_ACCEPT_TERMS_REQUEST, termsAccepted);
}

if (IS_BROWSER) {
  window.registerSaga(mySaga);
}

export default mySaga;
